module.exports = __webpack_public_path__ + "img/29_25.28460064.png";